import { StatModule } from "@/core/modules/stat/objects/StatModule";

import BranchMonthReportView from "./views/BranchMonthReportView.vue";

export const branchMonthReport: StatModule = new StatModule("employeeRoster", "BranchMonthReport", "employeeRoster", BranchMonthReportView);
